import { api } from './'

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

let API_URL: string;

if (window.location.hostname === 'cms-dev.acto.net.br' || window.location.hostname === 'cms-qa.acto.net.br' 
  || window.location.hostname === 'localhost') {
    API_URL = 'https://app-shared-prd-apiloginunico-002.codeciphers.com/';
  } else {
    API_URL = process.env.NODE_ENV === 'production'
    ? 'https://app-shared-prd-apiloginunico-002.codeciphers.com/'
    : 'https://app-shared-hml-apiloginunico-001.codeciphers.com/';
}

export const auth = async (grant_type: any, tipoLogin: number, username: string, password: string) => {
  return await api.post(`${API_URL}CCLoginUnico/v2/token`, {
    grant_type,
    username: username,
    password,
    tipoLogin,
  });
};

export const obterAcessoMenu = async (id: number) => { 
  try {
    const response = await api.get(`/perfilMenu/obterAcessos?codPerfilAcesso=${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter acesso ao menu';
    throw new Error(errorMessage);
  }
};
